<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item-dropdown :popper-opts="popperOpt">
                <template slot="button-content">
                    <i
                        class="cus-report"
                        :class="{
                            'nested-blink-indicator': hasPendingRequest
                        }"
                    ></i>
                    History
                </template>
                <loader v-if="_.isEmpty(stats)" />
                <template v-else>
                    <b-dropdown-item
                        href="#0"
                        @click="showList(VIEWS.SNAPSHOT)"
                    >
                        <i class="cus-image"></i>
                        View Snapshot
                    </b-dropdown-item>

                    <b-dropdown-item
                        href="#0"
                        @click="showList(VIEWS.ALL)"
                        v-if="_hasAccess('patient.record.view')"
                    >
                        <i class="cus-report"></i>
                        View All History ({{ stats.all_count }})
                    </b-dropdown-item>

                    <b-dropdown-item
                        href="#0"
                        @click="showList(VIEWS.COMMUNICATIONS)"
                        v-if="
                            _hasAccess('patient.communication.view') &&
                            stats.communication_count > 0
                        "
                    >
                        <i class="cus-comments"></i>
                        View Communications ({{ stats.communication_count }})
                    </b-dropdown-item>

                    <dropdown-nested
                        v-if="
                            _hasAccess('patient.record.view') &&
                            stats.diagnoses_count > 0
                        "
                        :title="{
                            text:
                                'View Diagnoses (' +
                                stats.diagnoses_count +
                                ')',
                            icon: 'cus-stethoscope'
                        }"
                        :list="diagnosisDropdown"
                        @trigger-function="diagnosesAction"
                    />

                    <dropdown-nested
                        v-if="
                            _hasAccess('patient.record.view') &&
                            stats.diagnostic_count > 0
                        "
                        :title="{
                            text:
                                'View Diagnostics (' +
                                stats.diagnostic_count +
                                ')',
                            icon: 'cus-chart-curve'
                        }"
                        :list="diagnosticDropdown"
                        @trigger-function="diagnosticAction"
                    />

                    <dropdown-nested
                        v-if="
                            stats.problem_count > 0 &&
                            _hasAccess('patient.record.view')
                        "
                        :title="{
                            text: 'View Problems (' + stats.problem_count + ')',
                            icon: 'cus-error'
                        }"
                        :list="problemsDropdown"
                        @trigger-function="problemAction"
                    />

                    <dropdown-nested
                        v-if="
                            stats.all_record_count > 0 &&
                            _hasAccess('patient.record.view')
                        "
                        :title="{
                            text:
                                'View Records (' + stats.all_record_count + ')',
                            icon: 'cus-page-white-stack'
                        }"
                        :list="recordsDropdown"
                        @trigger-function="recordAction"
                    />

                    <dropdown-nested
                        v-if="
                            stats.vital_count > 0 &&
                            _hasAccess('patient.record.view')
                        "
                        :title="{
                            text: 'View Vitals (' + stats.vital_count + ')',
                            icon: 'cus-heart'
                        }"
                        :list="vitalsDropdown"
                        @trigger-function="vitalAction"
                    />
                </template>
                <div v-if="_hasAccess('patient.record.view')">
                    <li class="dropdown-divider"></li>

                    <dropdown-nested
                        v-if="
                            _hasAccess('patient.record.create') &&
                            (isMobileExtensionEnabled || onlinePharmacyEnabled)
                        "
                        :title="{
                            text: 'View Rx Requests',
                            icon: 'cus-basket-put',
                            dot_indicator: hasPendingRequest
                        }"
                        :list="requestRefillsDropdown"
                        @trigger-function="rxRequestAction"
                    />

                    <b-dropdown-item
                        href="#0"
                        @click="showList(VIEWS.DECLINED_ITEMS)"
                    >
                        <i class="famfamfam-silk cus-pill-delete"></i>
                        View Declined Items
                    </b-dropdown-item>
                </div>
                <div
                    v-if="
                        _hasAccess('patient.communication.create') ||
                        _hasAccess('patient.record.create')
                    "
                >
                    <li class="dropdown-divider" v-if="!statusInActive"></li>

                    <dropdown-nested
                        v-if="
                            !statusInActive &&
                            _hasAccess('patient.communication.create') &&
                            _hasAccess('patient.communication.view')
                        "
                        :title="{
                            text: 'New Communication',
                            icon: 'cus-add'
                        }"
                        :list="commDropdown"
                        @trigger-function="getAction"
                    />

                    <b-dropdown-item
                        href="#0"
                        v-if="
                            !statusInActive &&
                            _hasAccess('patient.record.view') &&
                            _hasAccess('patient.record.create')
                        "
                        @click.stop.prevent="openModal('DIAGNOSIS')"
                    >
                        <i class="cus-add"></i>
                        New Diagnosis
                    </b-dropdown-item>

                    <b-dropdown-item
                        href="#0"
                        v-if="
                            !statusInActive &&
                            _hasAccess('patient.record.view') &&
                            _hasAccess('patient.record.create')
                        "
                        @click.stop.prevent="openModal('DIAGNOSTIC')"
                    >
                        <i class="cus-add"></i>
                        New Diagnostic
                    </b-dropdown-item>

                    <b-dropdown-item
                        href="#0"
                        v-if="
                            !statusInActive &&
                            _hasAccess('patient.record.view') &&
                            _hasAccess('patient.record.create')
                        "
                        @click.stop.prevent="openModal('PROBLEM')"
                    >
                        <i class="cus-add"></i>
                        New Problem
                    </b-dropdown-item>

                    <dropdown-nested
                        v-if="
                            !statusInActive &&
                            _hasAccess('patient.record.view') &&
                            _hasAccess('patient.record.create')
                        "
                        :title="{ text: 'New Record', icon: 'cus-add' }"
                        :list="newRecordDropdown"
                        @trigger-function="getAction"
                    />

                    <b-dropdown-item
                        href="#0"
                        v-if="
                            !statusInActive &&
                            _hasAccess('patient.record.view') &&
                            _hasAccess('patient.record.create')
                        "
                        @click.stop.prevent="openModal('VITAL')"
                    >
                        <i class="cus-add"></i>
                        New Vital
                    </b-dropdown-item>
                </div>
            </b-nav-item-dropdown>
        </template>
        <b-card-text>
            <snapshot
                v-if="currentView === VIEWS.SNAPSHOT"
                :key="componentKey"
                :patientDetails="patientDetails"
                @view-vitals="handleViewVitals"
            />
            <list-all-history
                v-if="currentView === VIEWS.ALL"
                :key="componentKey"
                @reload="showList"
                @reload-tab-count="reloadTabDocumentCount"
                :patientDetails="patientDetails"
            />
            <list-diagnostic
                v-if="currentView === VIEWS.DIAGNOSTIC"
                :key="componentKey"
                :category="currentCategory"
                :patientId="patientId"
            />
            <list-vital
                v-if="currentView === VIEWS.VITALS"
                :key="componentKey"
                :category="currentCategory"
                :patientId="patientId"
            />
            <list-problem
                v-if="currentView === VIEWS.PROBLEMS"
                :key="componentKey"
                :category="currentCategory"
                :patientId="patientId"
            />
            <list-communication
                v-if="currentView === VIEWS.COMMUNICATIONS"
                :key="componentKey"
                :category="currentCategory"
                :patientId="patientId"
                :patientDetails="patientDetails"
            />
            <list-diagnosis
                v-if="currentView === VIEWS.DIAGNOSES"
                :key="componentKey"
                :category="currentCategory"
                :patientId="patientId"
            />
            <list-note
                v-if="currentView === VIEWS.NOTES"
                :key="componentKey"
                @open-diagnosis="diagnosesAction('ALL')"
                @reload-tab-count="reloadTabDocumentCount"
                :patientId="patientId"
            />
            <list-record
                v-if="currentView === VIEWS.RECORDS"
                :key="componentKey"
                :category="currentCategory"
                :patientDetails="patientDetails"
                @reload-tab-count="reloadTabDocumentCount"
                v-on="$listeners"
            />
            <list-refill-request
                v-if="currentView === VIEWS.REFILL_REQUEST"
                :category="currentCategory"
                :key="componentKey"
                :patientId="patientId"
                :patientProfile="true"
                @reload-tab-count="getRxRequest"
            />
            <list-declined-items
                v-if="currentView === VIEWS.DECLINED_ITEMS"
                :key="componentKey"
                :patientId="patientId"
            />
        </b-card-text>
    </b-tab>
</template>
<script>
import Snapshot from "@/components/patient-snapshot/snapshot";
import HISTORY from "@/constants/history";
import EXTENSIONS from "@/constants/extensions";
import Records from "@/services/records";
import DropdownNested from "@/components/elements/dropdown/dropdown-nested";
import { forEach, sortBy, concat } from "lodash";
import REQUEST from "@/constants/refill-requests";
import CVITAL from "@/constants/vital";

export default {
    components: {
        Snapshot,
        DropdownNested,
        Loader: () => import("@/components/elements/loader"),
        ListNote: () => import("@/components/medical-notes/note-list"),
        ListVital: () => import("@/components/vitals/vital-list"),
        ListRecord: () => import("@/components/medical-records/record-list"),
        ListProblem: () => import("@/components/problems/problem-list"),
        ListAllHistory: () =>
            import("@/components/patient-history/history-all-list"),
        ListDiagnosis: () =>
            import("@/components/patient-diagnosis/diagnosis-list"),
        ListDiagnostic: () =>
            import("@/components/patient-diagnostic/diagnostic-list"),
        ListCommunication: () =>
            import("@/components/patient-communications/communication-list"),
        ListRefillRequest: () =>
            import("@/components/refill-requests/refill-request-list"),
        ListDeclinedItems: () =>
            import("@/components/item-declined/item-declined-list")
    },
    props: {
        openList: {
            default: null
        },
        patientDetails: {
            type: Object
        }
    },
    watch: {
        openList: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    let category = null;
                    // Check if it exists first
                    if (Object.keys(this.$route.query).length > 0) {
                        const showTab = this.$route.query;
                        category = Number(showTab.status);
                    }
                    this.showList(newValue, category);
                }
            }
        }
    },
    data() {
        return {
            currentView: "",
            currentCategory: null,
            HISTORY,
            componentKey: 0,
            diagnosis: [],
            diagnosisDropdown: [],
            diagnosticDropdown: [],
            problemsDropdown: [],
            recordsDropdown: [],
            vitalsDropdown: [],
            requestRefillsDropdown: [],
            commDropdown: [
                {
                    text: "Log Communication",
                    icon: "cus-add",
                    function_code: "LOG_COMM",
                    isModal: true
                },
                {
                    text: "Send Email",
                    icon: "cus-email",
                    function_code: "EMAIL",
                    isModal: true
                }
            ],
            newRecordDropdown: [
                {
                    text: "Bundle",
                    icon: "cus-page-white-stack",
                    function_code: "BUNDLE",
                    isModal: true
                },
                { icon: "divider" },
                {
                    text: "Medical Note",
                    icon: "cus-clipboard-text",
                    function_code: "MEDICAL_NOTE",
                    isModal: true
                },
                {
                    text: "Medical Record",
                    icon: "cus-page-white-stack",
                    function_code: "MEDICAL_RECORD",
                    isModal: true
                }
            ],
            popperOpt: {
                placement: "bottom-start",
                modifiers: {
                    flip: {
                        enabled: false
                    }
                },
                positionFixed: true
            },
            hasPendingRequest: false,
            REQUEST
        };
    },
    computed: {
        patientId() {
            return this.patientDetails ? this.patientDetails.id : null;
        },
        statusInActive() {
            return this.$store.getters["patient/statusInActive"];
        },
        diagnosticList() {
            return this.$store.getters["references/diagnostics"];
        },
        isMobileExtensionEnabled() {
            return this._isExtensionEnabled(
                EXTENSIONS.CODE.CODE_CLIENT_MOBILE_APP
            );
        },
        onlinePharmacyEnabled() {
            return (
                this._isExtensionEnabled(EXTENSIONS.CODE.CODE_VETSOURCE) ||
                this._isExtensionEnabled(EXTENSIONS.CODE.CODE_VETCOVE_ONLINE)
            );
        },
        stats() {
            let stats = this.$store.getters["patient/counts"];
            this.updateDiagnosesStats(stats);
            this.updateDiagnosticStats(stats);
            this.updateProblemsStats(stats);
            this.updateRecordsStats(stats);
            this.updateVitalStats(stats);

            return stats;
        },
        VIEWS() {
            return HISTORY.VIEWS;
        },
        CVITAL() {
            return CVITAL;
        }
    },
    created() {
        if (_.isEmpty(this.diagnosticList)) {
            this.$store.dispatch("references/getDiagnostics");
        }
    },
    mounted() {
        this.checkCommunicationDropdown();
        if (_.isEmpty(this.openList)) {
            this.showDefaultView();
        }

        if (this.isMobileExtensionEnabled || this.onlinePharmacyEnabled) {
            this.getRxRequest();
        }
    },
    methods: {
        async showDefaultView() {
            let setting = await this._getSetting();

            if (setting.patient_history === 1) {
                this.showList(this.VIEWS.SNAPSHOT);
            } else {
                this.showList(this.VIEWS.RECORDS);
            }
        },
        updateDiagnosesStats(stats) {
            this.diagnosisDropdown = [];

            if (stats) {
                if (stats.diagnoses_count > 0) {
                    this.diagnosisDropdown.push({
                        text:
                            "View All Diagnoses (" +
                            stats.diagnoses_count +
                            ")",
                        icon: "cus-stethoscope",
                        function_code: "ALL"
                    });
                }

                if (stats.open_diagnoses_count > 0) {
                    this.diagnosisDropdown.push({
                        text:
                            "View Open Diagnoses (" +
                            stats.open_diagnoses_count +
                            ")",
                        icon: "cus-stethoscope",
                        function_code: "opened"
                    });
                }

                if (stats.close_diagnoses_count > 0) {
                    this.diagnosisDropdown.push({
                        text:
                            "View Closed Diagnoses (" +
                            stats.close_diagnoses_count +
                            ")",
                        icon: "cus-stethoscope",
                        function_code: "closed"
                    });
                }
            }
        },
        updateDiagnosticStats(stats) {
            this.diagnosticDropdown = [];
            let self = this;
            if (stats) {
                if (stats.diagnostic_count > 0) {
                    this.diagnosticDropdown.push({
                        text:
                            "All Diagnostics (" + stats.diagnostic_count + ")",
                        icon: "cus-chart-curve",
                        function_code: "ALL"
                    });

                    this.diagnosticDropdown.push({ icon: "divider" });

                    if (this.diagnosticList) {
                        _.forEach(this.diagnosticList, function (diagnostic) {
                            let diagnosticStat =
                                stats.all_vital_count[diagnostic.id];
                            if (diagnosticStat > 0) {
                                self.diagnosticDropdown.push({
                                    text:
                                        diagnostic.vital +
                                        " (" +
                                        diagnosticStat +
                                        ")",
                                    icon: "",
                                    function_code: diagnostic.id
                                });
                            }
                        });
                    }
                }
            }
        },
        updateProblemsStats(stats) {
            this.problemsDropdown = [];

            if (stats) {
                if (stats.problem_count > 0) {
                    this.problemsDropdown.push({
                        text: "View All Problems (" + stats.problem_count + ")",
                        icon: "cus-error",
                        function_code: "ALL"
                    });

                    if (stats.open_problem_count > 0) {
                        this.problemsDropdown.push({
                            text:
                                "View Open Problems (" +
                                stats.open_problem_count +
                                ")",
                            icon: "cus-error",
                            function_code: "opened"
                        });
                    }

                    if (stats.close_problem_count > 0) {
                        this.problemsDropdown.push({
                            text:
                                "View Closed Problems (" +
                                stats.close_problem_count +
                                ")",
                            icon: "cus-error",
                            function_code: "closed"
                        });
                    }
                }
            }
        },
        updateRecordsStats(stats) {
            this.recordsDropdown = [];

            if (stats) {
                if (stats.all_record_count > 0) {
                    this.recordsDropdown.push({
                        text: "All Records (" + stats.all_record_count + ")",
                        icon: "cus-page-white-stack",
                        function_code: "ALL"
                    });

                    this.recordsDropdown.push({ icon: "divider" });
                }

                if (stats.note_count > 0) {
                    this.recordsDropdown.push({
                        text: "Medical Notes (" + stats.note_count + ")",
                        icon: "cus-page-white-stack",
                        function_code: "MEDICALNOTES"
                    });

                    this.recordsDropdown.push({ icon: "divider" });
                }

                if (stats.record_type_count) {
                    let list = [];
                    forEach(stats.record_type_count, function (value, key) {
                        if (value.count > 0) {
                            list.push({
                                text: value.name + " (" + value.count + ")",
                                icon: value.icon_class,
                                function_code: key
                            });
                        }
                    });

                    let sortedList = sortBy(list, ["text"]);

                    this.recordsDropdown = concat(
                        this.recordsDropdown,
                        sortedList
                    );
                }
            }
        },
        updateVitalStats(stats) {
            this.vitalsDropdown = [];

            if (stats) {
                if (stats.vital_count > 0) {
                    this.vitalsDropdown.push({
                        text: "All Vitals (" + stats.vital_count + ")",
                        icon: "cus-heart",
                        function_code: "VITAL_ALL"
                    });

                    this.vitalsDropdown.push({ icon: "divider" });

                    if (stats.all_vital_count) {
                        if (stats.all_vital_count[CVITAL.TYPE.CAPILLARY] > 0) {
                            this.vitalsDropdown.push({
                                text:
                                    "Capillary Refill Time (" +
                                    stats.all_vital_count[
                                        CVITAL.TYPE.CAPILLARY
                                    ] +
                                    ")",
                                function_code: CVITAL.TYPE.CAPILLARY, //6
                                icon: ""
                            });
                        }

                        if (stats.all_vital_count[CVITAL.TYPE.HEARTRATE] > 0) {
                            this.vitalsDropdown.push({
                                text:
                                    "Heart Rate (" +
                                    stats.all_vital_count[
                                        CVITAL.TYPE.HEARTRATE
                                    ] +
                                    ")",
                                function_code: CVITAL.TYPE.HEARTRATE, //1,
                                icon: ""
                            });
                        }

                        if (
                            stats.all_vital_count[CVITAL.TYPE.RESPIRATION] > 0
                        ) {
                            this.vitalsDropdown.push({
                                text:
                                    "Respiration (" +
                                    stats.all_vital_count[
                                        CVITAL.TYPE.RESPIRATION
                                    ] +
                                    ")",
                                function_code: CVITAL.TYPE.RESPIRATION, //2,
                                icon: ""
                            });
                        }

                        if (
                            stats.all_vital_count[CVITAL.TYPE.TEMPERATURE] > 0
                        ) {
                            this.vitalsDropdown.push({
                                text:
                                    "Temperature (" +
                                    stats.all_vital_count[
                                        CVITAL.TYPE.TEMPERATURE
                                    ] +
                                    ")",
                                function_code: CVITAL.TYPE.TEMPERATURE, //3,
                                icon: ""
                            });
                        }

                        if (stats.all_vital_count[CVITAL.TYPE.WEIGHT] > 0) {
                            this.vitalsDropdown.push({
                                text:
                                    "Weight (" +
                                    stats.all_vital_count[CVITAL.TYPE.WEIGHT] +
                                    ")",
                                function_code: CVITAL.TYPE.WEIGHT, //4,
                                icon: ""
                            });
                        }
                    }
                }
            }
        },
        openModal(key) {
            this.$emit("open-modal", key);
        },
        showList(view, category = null) {
            this.currentView = view;
            if (category != null) {
                this.currentCategory = category;
            }
            this.componentKey++;
        },
        getDiagnosis() {
            Records.getPatientDiagnosis(this.patientId).then(() => {
                // console.log('response', response);
            });
        },
        getAction(type) {
            // modals
            if (
                [
                    "LOG_COMM",
                    "EMAIL",
                    "SMS",
                    "MEDICAL_RECORD",
                    "MEDICAL_NOTE",
                    "BUNDLE"
                ].includes(type)
            ) {
                this.openModal(type);
            }

            // content/list
            else {
                switch (type) {
                    case "VITAL_ALL":
                        this.currentView = this.VIEWS.VITALS;
                        break;
                }

                this.componentKey++;
            }
        },
        vitalAction(type) {
            this.currentCategory = null;

            if (type !== "VITAL_ALL") {
                this.currentCategory = type;
            }

            this.currentView = this.VIEWS.VITALS;
            this.componentKey++;
        },
        diagnosticAction(type) {
            this.currentCategory = null;

            if (type !== "ALL") {
                this.currentCategory = type;
            }

            this.currentView = this.VIEWS.DIAGNOSTIC;
            this.componentKey++;
        },
        problemAction(type) {
            this.currentCategory = null;

            if (type !== "ALL") {
                this.currentCategory = type;
            }

            this.currentView = this.VIEWS.PROBLEMS;
            this.componentKey++;
        },
        diagnosesAction(type) {
            this.currentCategory = null;

            if (type !== "ALL") {
                this.currentCategory = type;
            }

            this.currentView = this.VIEWS.DIAGNOSES;
            this.componentKey++;
        },
        rxRequestAction(type) {
            this.currentCategory = null;

            if (type !== "ALL") {
                this.currentCategory = type - 1;
            }

            this.currentView = this.VIEWS.REFILL_REQUEST;
            this.componentKey++;
        },
        recordAction(type) {
            this.currentCategory = null;

            if (type === "MEDICALNOTES") {
                this.currentView = this.VIEWS.NOTES;
            } else if (type !== "ALL") {
                this.currentCategory = type;
                this.currentView = this.VIEWS.RECORDS;
            } else {
                this.currentView = this.VIEWS.RECORDS;
            }

            this.componentKey++;
        },
        checkCommunicationDropdown() {
            if (
                this._isExtensionEnabled(EXTENSIONS.CODE.CODE_SMS) ||
                this._isExtensionEnabled(EXTENSIONS.CODE.CODE_2_WAY_MESSAGING)
            ) {
                this.commDropdown.push({
                    text: "Send SMS",
                    icon: "cus-phone",
                    function_code: "SMS",
                    isModal: true
                });
            }
        },
        getRxRequest() {
            let params = {};

            var pendingCount = 0;
            var rejectedCount = 0;
            var approvedCount = 0;
            var completedCount = 0;

            Records.getRecordRefillRequestsCountByPatientId(this.patientId)
                .then(response => {
                    response.resource.forEach(data => {
                        if (
                            data.label.toLowerCase() === REQUEST.LABEL.PENDING
                        ) {
                            pendingCount = data.count;
                            if (pendingCount > 0) {
                                this.hasPendingRequest = true;
                            } else {
                                this.hasPendingRequest = false;
                            }
                        }
                        if (
                            data.label.toLowerCase() === REQUEST.LABEL.REJECTED
                        ) {
                            rejectedCount = data.count;
                        }
                        if (
                            data.label.toLowerCase() === REQUEST.LABEL.APPROVED
                        ) {
                            approvedCount = data.count;
                        }
                        if (
                            data.label.toLowerCase() === REQUEST.LABEL.COMPLETED
                        ) {
                            completedCount = data.count;
                        }
                    });
                })
                .catch(error => {
                    console.error(error);
                });

            Records.getRecordRefillRequests(this.patientId, params)
                .then(response => {
                    let meta = response.meta;

                    this.requestRefillsDropdown.push({
                        text: "All Request (" + meta.total + ")",
                        icon: "cus-basket-put",
                        function_code: "ALL"
                    });

                    if (meta.total > 0) {
                        this.requestRefillsDropdown.push({
                            text: "Pending Request (" + pendingCount + ")",
                            icon: "cus-error",
                            function_code: 1 // PENDING = 0
                        });

                        this.requestRefillsDropdown.push({
                            text: "Approved Request (" + approvedCount + ")",
                            icon: "cus-accept",
                            function_code: 2 // APPROVED = 1
                        });

                        this.requestRefillsDropdown.push({
                            text: "Denied Request (" + rejectedCount + ")",
                            icon: "cus-cancel",
                            function_code: 3 // REJECTED = 2
                        });

                        this.requestRefillsDropdown.push({
                            text: "Completed Request (" + completedCount + ")",
                            icon: "cus-tick",
                            function_code: 4
                        });
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        },
        reloadTabDocumentCount() {
            this.$emit("reload-document-count");
        },
        handleViewVitals(vitalTypeString) {
            let vitalCategory = null;
            switch (vitalTypeString) {
                case "WEIGHT":
                    vitalCategory = this.CVITAL.TYPE.WEIGHT;
                    break;
                case "TEMPERATURE":
                    vitalCategory = this.CVITAL.TYPE.TEMPERATURE;
                    break;
                case "HEARTRATE":
                    vitalCategory = this.CVITAL.TYPE.HEARTRATE;
                    break;
                case "RESPIRATION":
                    vitalCategory = this.CVITAL.TYPE.RESPIRATION;
                    break;
                default:
                    vitalCategory = "VITAL_ALL"; // Fallback to all vitals if type is unknown
                    break;
            }
            this.vitalAction(vitalCategory);
        }
    }
};
</script>
